import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ParentContext } from '../../contexts/parent-component';
import { Text } from './text-block-css';

const TextBlock = ({ type, text }) => {
  const { backgroundColor } = useContext(ParentContext);
  return <Text type={type} parentBg={backgroundColor || undefined}>{text}</Text>;
};

TextBlock.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['Callout', 'Callout With No Bottom Padding', 'Caption', 'Emphasised Paragraph']).isRequired,
};

export default TextBlock;
